module.exports = __webpack_public_path__ + "static/media/favoriteStarOff.51ddc2c0.svg";